var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPenGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-icon-pen-green-white-check_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-pen-green-white-check_1",
    "data-name": "icon-pen-green-white-check \\u2013 1",
    clipPath: "url(#clip-icon-pen-green-white-check_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_643",
    "data-name": "Group 643",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_105",
    "data-name": "Ellipse 105",
    transform: "translate(0 0)",
    fill: "#2f0",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-pen",
    "data-name": "Icon awesome-pen",
    d: "M5.844,1.875,8.417,4.448,2.829,10.036l-2.294.253A.482.482,0,0,1,0,9.756l.255-2.3L5.844,1.875Zm4.165-.383L8.8.283a.965.965,0,0,0-1.365,0L6.3,1.42,8.872,3.993l1.137-1.137a.965.965,0,0,0,0-1.365Z",
    transform: "translate(4.854 4.854)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPenGreen);
export default __webpack_public_path__ + "static/media/icon-pen-green.ca4fc956f17515f5d638f154d3bc0dd0.svg";
export { ForwardRef as ReactComponent };